'use strict';

var $ = require('jquery');

module.exports = function () {

  function setTabLinkActive(tabLinks) {
    for (var i = 0; i < tabLinks.length; i++) {
      $(tabLinks[i]).addClass('active');
    }
  }

  function setTabLinkInactive(tabLinks) {
    for (var i = 0; i < tabLinks.length; i++) {
      $(tabLinks[i]).removeClass('active');
    }
  }

  function showTab(tabPanels) {
    for (var i = 0; i < tabPanels.length; i++) {
      $(tabPanels[i]).removeClass('inactive').addClass('active');
    }
  }

  function hideTab(tabPanels) {
    for (var i = 0; i < tabPanels.length; i++) {
      $(tabPanels[i]).removeClass('active').addClass('inactive');
    }
  }

  function init() {
    var allTabLinks = $('[data-binding="tab-link"], [data-binding="mobile-tab-link"]');
    var allTabPanels = $('[data-binding="tab-panel"]');

    hideTab(allTabPanels);
    showTab(allTabPanels.first());

    setTabLinkActive(allTabLinks.filter(function () {
      return $(this).attr('href') === allTabLinks.first().attr('href');
    }));

    allTabLinks.on('click', function (e) {
      e.preventDefault();

      var href = $(this).attr('href');
      var currentTab = allTabPanels.filter('.active');
      var correspondingTab = allTabPanels.filter(href);

      var isAlreadyActive = correspondingTab.hasClass('active');

      if (!isAlreadyActive) {
        setTabLinkInactive(allTabLinks);
        //setTabLinkActive([buttonClicked]);
        setTabLinkActive(allTabLinks.filter(function () {
          return $(this).attr('href') === href;
        }));

        showTab(correspondingTab);
        hideTab(currentTab);
      }
    });
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/satellite-map-list-tabs.js
// module id = 497
// module chunks = 0